<template>
  <div class="site-wrapper" :style="cssVars">
    <main class="site-main">
      <div style="position: absolute; left: 0; right: 0; top: 50%; transform: translateY(-50%);">
        <div class="grid-container grid-container--x-small" style="max-width: 480px;">
          <div v-if="!useReferral">
            <div class="panel text-center">
              <div style="margin-bottom: 60px;">
                <h1>Welcome to Vendor Consignment</h1>

                <p>Automatic vendor tracking tool for
                  consignment businesses.</p>
              </div>

              <button class="button--wide" @click="install">Install App</button>

              <div class="text-center" style="padding: 15px;">
                <a @click="startReferral">Do you have a referral code?</a>
              </div>
            </div>
          </div>
          <div class="login-form" v-else>
            <div class="panel">
              <div style="margin-bottom: 60px;">
                <h2>Referral Code</h2>

                <p>If you have received a referral code, enter
                  this now.</p>
              </div>

              <div class="text-left">
                <div class="form-field">
                  <label for="referral-code">Referral Code</label>
                  <input id="referral-code" name="referral-code" type="text" @keyup.enter="submitReferral">
                </div>

                <p class="text-alert-color text-right"
                   v-if="loginError !== null" v-html="loginError"></p>

                <button class="button--wide" type="submit" @click="submitReferral">Submit & Install</button>

                <div class="text-center" style="padding: 15px;">
                  <a @click="endReferral">Go back, I do not have a referral code.</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import env from '@/mixins/env'
import client from '@/mixins/client'

export default {
  name: 'site',
  mixins: [client],
  data: function () {
    return {
      loginError: null,
      useReferral: false
    }
  },
  computed: {
    cssVars () {
      return {
        '--primary-color': '#eb008c',
        '--primary-dark-color': '#eb008c',
        '--secondary-color': '#7101a5',
        '--font-color': '#333333',
        '--button-text-color': '#ffffff'
      }
    }
  },
  methods: {
    install: function () {
      document.location.href = env.api_root() + '/?' + env.params()
    },
    startReferral: function () {
      this.useReferral = true
    },
    endReferral: function () {
      this.useReferral = false
    },
    submitReferral: function () {
      const referralCodeElement = document.getElementById('referral-code')
      document.location.href = env.api_root() + '/?' + env.params() + '&referral=' + referralCodeElement.value.trim()
    }
  }
}
</script>

<style lang="scss">
@import 'styles/variables';
@import 'styles/mixins';

.login-form {
  padding: 60px 0;
  text-align: center;

  .panel {
    margin: 0 auto;
    max-width: 500px;

    h2,
    label {
      color: var(--font-color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Referral.vue